<template>
    <div class="list-raovat list-raovat-epxired">
        <fillter
        v-model="data_fillter"
        @input="getData($event)"
        :arrTotalAll="arrTotalAll"
        :arrStatusOrder="arrStatusOrder"
        :idSelect="idSelect"/>
        <div class="mb-1">
            <div class="">
                Tổng giá trị đơn hàng : <span class="font-weight-bold text-danger" v-html="total_money+' đ'"></span> 
            </div>
        </div>
        <table :class="{
                'table': true,
                'table-bordered': $detect == 'web'
            }">
            <thead v-if="$detect == 'web'">
                <tr>
                    <th scope="col"  class="text-center">
                        Thông tin sản phẩm
                    </th>
                    <th scope="col" >Thông tin thanh toán</th>
                    <th scope="col" >Thông tin người nhận</th>
                    <th scope="col" class="text-center">Trạng thái</th>
                </tr>
            </thead>
            <thead v-else>
                <tr>
                    <th colspan="2" class="text-center py-1">Thông tin đơn hàng</th>
                </tr>
            </thead>
            <tbody v-if="order.length == 0">
                <tr>
                    <td colspan="4" class="text-center text-muted">Không có dữ liệu</td>
                </tr>
            </tbody>
            <tbody v-else-if="$detect == 'web'" v-for="(item,index) in order" :key="index">
                <tr><td colspan="4" style="padding: 10px;"></td></tr>
                <tr >
                    <td colspan="4" class="order_info_title show_notify" :rel="'show_notify_'+item.ord_id">
                        <i class="ion-md-calendar float-left mr-2"></i>
                        <p class="fl time_active float-left mb-0 mr-3">{{ item.ord_create_time }}</p>
                        <p class="fl orders_code float-left mb-0">Mã đơn hàng:  <a href="javascript:;"><span>{{ item.ord_code }}</span></a></p>
                        <div class="fr orders_notify float-right" :id="'show_notify_'+item.ord_id" style="display: block;">
                            <span style="cursor: pointer; background: #f58019; padding: 6px 8px; color: #FFFFFF; border-radius: 4px; border: 1px solid #e46b18;" class="text_notify" @click="update(item,index)"><strong>Cập nhật đơn hàng</strong></span>
                        </div>
                    </td>
                </tr>
                <tr class="position-relative">
                    <td width="270"class="text-center" >
                        <div :class="{
                            'box d-flex' : true,
                            'mb-3' : db_order_product[item.ord_id].length > 1
                        }" v-for="(v, k) in db_order_product[item.ord_id]" :key="k" v-if="db_order_product[item.ord_id]" >
                            <div class="pro_image w-20 mr-1">
                                <img :src="v.od_picture" 
                                class="mw-100 mh-100 img-web" onerror="errorImage(this)" alt="" />
                            </div>
                            <div class="informarion w-80">
                                <p class="pro_name mb-0">
                                    <a :href="v.od_product_link" target="_blank" class="text-primary" style="color: #333;" :title="v.od_product_name">
                                        {{ v.od_product_name.length > 75 ? v.od_product_name.substr(0,75)+'...' : v.od_product_name}}
                                    </a>
                                </p>
                                <i v-if="v.od_product_name_size_color != ''">{{ v.od_product_name_size_color }}</i>
                                <p class="pro_oldprice mb-0 text-danger" v-if="v.od_product_sale_price != v.od_product_price" v-html="v.pro_price"></p>
                                <p class="mb-0"><span class="pro_price text-danger" v-html="v.pro_price"></span> x <span>{{v.od_product_quantity }}</span></p>
                            </div>
                        </div>
                    </td>
                    <td width="200" class="position-relative">
                        <p class="mb-0"><b>Tổng giá trị: <span class="price text-danger" v-html="item.total_money"></span></b></p>
                        <p class="mb-0"><i class="font-12px">Chưa bao gồm phí vận chuyển</i></p>
                    </td>
                    <td width="200">
                        <div class="bold box_name_user">
                            <span>{{ item.ord_name }}</span>
                        </div>
                        <div class="text-primary fs-13px">{{ item.ord_phone }}</div>
                        <div class="text-primary fs-13px">{{ item.ord_email }}</div>
                        <p class="mb-0 fs-13px">{{item.ord_address}} {{ arrDistrict[item.ord_district] ? ' - ' + arrDistrict[item.ord_district].cit_name : '' }} {{ arrCity[item.ord_city] ? ' - ' +arrCity[item.ord_city].cit_name : ''}}</p>
                        <div v-if="item.ord_otherinfo != ''" class="fs-12px">
                            <i>Ghi chú : {{ item.ord_otherinfo }}</i>
                        </div>
                    </td>
                     <td width="150" class="text-center">
                        <div v-if="arrStatusOrder[item.ord_status]" align="center" style="padding: 6px 8px;" :class="{
                                'bg-white border font-weight-bold'      : true,
                                'text-primary border-primary' : item.ord_status == 2,
                                'text-info border-info' : item.ord_status == 1,
                                'text-danger border-danger' : item.ord_status == 100,
                                'text-success border-success' : item.ord_status == 5,
                            }">
                            {{ arrStatusOrder[item.ord_status] ? arrStatusOrder[item.ord_status].title : ''}}
                        </div>
                       <i class="fs-12px mt-1">{{ item.ord_estore_note }}</i>
                    </td>
                </tr>
            </tbody>
            <tbody v-else v-for="(item,index) in order" :key="index">
                <tr v-if="index > 0">
                    <td colspan="2" class="p-0">
                        <div class="progress">
                            <div class="progress-bar progress-bar-striped bg-secondary" role="progressbar" style="width: 100%" aria-valuenow="100" aria-valuemin="0" aria-valuemax="100"></div>
                        </div>
                    </td>
                </tr>
                <tr class="table-mobile">
                    <td colspan="2">
                        <i class="ion-md-calendar float-left mr-2"></i>
                        <p class="fl time_active float-left mb-0 mr-3">{{ item.ord_create_time }}</p>
                        <p class="fl orders_code float-left mb-0">Mã đơn hàng:  <a href="javascript:;"><span>{{ item.ord_code }}</span></a></p>
                    </td>
                </tr>
                <tr class="table-mobile">
                    <td colspan="2">
                        <div :class="{
                            'box d-flex' : true,
                            'pb-2' : db_order_product[item.ord_id].length > 1
                        }" v-for="(v, k) in db_order_product[item.ord_id]" :key="k" v-if="db_order_product[item.ord_id]" >
                            <div class="pro_image w-15 mr-2">
                                <img :src="v.od_picture" 
                                class="mw-100 mh-100 img-web" onerror="errorImage(this)" alt="" />
                            </div>
                            <div class="informarion w-85">
                                <p class="pro_name mb-0">
                                    <a :href="v.od_product_link" target="_blank" class="text-primary" style="color: #333;" :title="v.od_product_name">
                                        {{ v.od_product_name.length > 75 ? v.od_product_name.substr(0,75)+'...' : v.od_product_name}}
                                    </a>
                                </p>
                                <i v-if="v.od_product_name_size_color != ''">{{ v.od_product_name_size_color }}</i>
                                <p class="pro_oldprice mb-0 text-danger" v-if="v.od_product_sale_price != v.od_product_price" v-html="v.pro_price"></p>
                                <p class="mb-0"><span class="pro_price text-danger" v-html="v.pro_price"></span> x <span>{{v.od_product_quantity }}</span></p>
                            </div>
                        </div>
                    </td>
                </tr>
                <tr class="table-mobile">
                    <td width="50%">
                        <p class="mb-0"><b>Tổng giá trị: <span class="price text-danger" v-html="item.total_money"></span></b></p>
                        <p class="mb-0"><i class="font-12px">Chưa bao gồm phí vận chuyển</i></p>
                    </td>
                    <td width="50%">
                        <div class="bold box_name_user">
                            <span>{{ item.ord_name }}</span>
                        </div>
                        <div class="text-primary fs-13px">{{ item.ord_phone }}</div>
                        <div class="text-primary fs-13px">{{ item.ord_email }}</div>
                        <p class="mb-0 fs-13px">{{item.ord_address}} {{ arrDistrict[item.ord_district] ? ' - ' + arrDistrict[item.ord_district].cit_name : '' }} {{ arrCity[item.ord_city] ? ' - ' +arrCity[item.ord_city].cit_name : ''}}</p>
                        <div v-if="item.ord_otherinfo != ''" class="fs-12px">
                            <i>Ghi chú : {{ item.ord_otherinfo }}</i>
                        </div>
                    </td>
                </tr>
                <tr class="table-mobile" v-if="item.ord_estore_note != '' && item.ord_estore_note != null">
                    <td colspan="2">
                        <i class="fs-12px mt-1">{{ item.ord_estore_note }}</i>
                    </td>
                </tr>
                <tr class="table-mobile">
                    <td>
                        <div v-if="arrStatusOrder[item.ord_status]" align="center" style="padding: 6px 8px;" :class="{
                                'bg-white border font-weight-bold'      : true,
                                'text-primary border-primary fs-13px' : item.ord_status == 2,
                                'text-info border-info' : item.ord_status == 1,
                                'text-danger border-danger' : item.ord_status == 100,
                                'text-success border-success' : item.ord_status == 5,
                            }">
                            {{ arrStatusOrder[item.ord_status] ? arrStatusOrder[item.ord_status].title : ''}}
                        </div>
                     <!--   <i class="fs-12px mt-1">{{ item.ord_estore_note }}</i> -->
                    </td>
                    <td>
                        <div class="fr orders_notify text-center" :id="'show_notify_'+item.ord_id" align="top">
                            <div style="cursor: pointer; background: #f58019; padding: 6px 8px; color: #FFFFFF; border-radius: 4px; border: 1px solid #e46b18;" class="text_notify" @click="update(item,index)">Cập nhật đơn hàng</div>
                        </div>
                    </td>
                </tr>
            </tbody>
        </table>
        <paginate
            :current_page="current_page"
            :next_page="next_page"
            :last_page="last_page"
            :callData="getUserCategory"/>
        <actionDialog
            :action="action"
            :visible.sync="dialog"
            :data="itemaction"
            :arrStatusOrder="arrStatusOrder"
            :multiple="false"/>
    </div>
</template>

<script>
import { availability, destroy } from '@/config/product';
export default {
    components: {
        fillter: () => import('./fillter.vue'),
        actionDialog : () => import('./actionDialog.vue'),
        paginate: () => import('@/components/layout/pagination.vue'),
    },
    data() {
        return {
            iCat : 0,
            order: [],
            idSelect: [],
            last_page: 0,
            next_page: 0,
            current_page: 0,
            countTotal : 0,
            countSuccess: 0,
            countConfirm : 0,
            total_money : 0,
            countHasfail: 0,
            conntNewOrders : 0,
            arrTotalAll : [],
            data_fillter: {
                status: -2,
            },
            selectAll: false,
            loading: '',
            loadingAction: '',
            db_order_product : [],
            arrCity: [],
            arrDistrict : [],
            arrStatusOrder : [],
            arrNumber : [],
            action: '', 
            dialog: false, 
            itemaction: '', // data xử lý đơn



        }
    },
    created() {
        this.getUserCategory(1);
        this.$eventBus.$on('call-page-expire', () => {
            this.idSelect = [];
            this.getDataAction(this.current_page);
        });
    },
    methods: {
        actionAdd(check){
            this.action = check;
            this.dialog = true;
        },
        update(item,key){
            this.itemaction = item;
            this.action = 'edit';
            this.dialog = true;
        },
        getUserCategory(page) {
            let params = {
                page: page,
                status: this.data_fillter.status,
            };
            this.idSelect = [];
            this.selectAll = false;
            apiGet('v2/profile/products/order', params).then(res => {
                this.order = res.data.db_listing.data;
                this.last_page = res.data.db_listing.last_page;
                this.next_page = res.data.db_listing.next_page;
                this.current_page = res.data.db_listing.current_page;
                this.selectAll = false;
                this.db_order_product =  res.data.db_order_product;
                this.countTotal     =   res.data.countTotal;
                this.countSuccess = res.data.countSuccess;
                this.countConfirm = res.data.countConfirm;
                this.total_money = res.data.total_money;
                this.countHasfail = res.data.countHasfail;
                this.conntNewOrders = res.data.conntNewOrders;
                this.arrDistrict = res.data.arrDistrict;
                this.arrStatusOrder = res.data.arrStatusOrder;
                this.arrCity = res.data.arrCity;
                this.arrTotalAll = res.data.total_all;
                this.arrNumber.countSuccess     = res.data.countSuccess;
                this.arrNumber.countConfirm     = res.data.countConfirm;
                this.arrNumber.countHasfail     = res.data.countHasfail;
                this.arrNumber.conntNewOrders   = res.data.conntNewOrders;


            })

        },
        async destrory(item, index = null){
            this.loading = index;
            this.loadingAction = 'destrory';
            await this.$confirm('Bạn có chắc chắn xóa danh mục sản phẩm này?', 'Xóa danh mục sản phẩm', {
                confirmButtonText: 'Đồng ý',
                cancelButtonText: 'Hủy',
                type: 'error'
            }).then(async res => {
                await apiPost('v2/profile/products/delete_user_category', {
                    record_id: item.iCat,
                }).then(res => {
                    this.$message({
                            message: res.message,
                            type: 'success',
                            center: true,
                        });
                }).catch(err => {
                    if(err.status == 410){
                        this.$message({
                            message: err.data.message,
                            type: 'error',
                            center: true,
                        });
                        
                     }
                })
            }).catch(() => {})
            
            await this.getDataAction(this.current_page);
        },
        getData(data){
            this.data_fillter.keyword_code = data.keyword_code;
            this.data_fillter.status = data.status;
            this.data_fillter.keyword_name = data.keyword_name;
            this.data_fillter.keyword_phone = data.keyword_phone;
            this.data_fillter.keyword_email = data.keyword_email;
            this.data_fillter.ord_date_end = data.ord_date_end;
            this.data_fillter.ord_date_start = data.ord_date_start;

            this.getDataAction(1);
        },
        async getDataAction(page){
            if(page < 1) return;
            let params = {
                page: page,
                status: this.data_fillter.status,
                keyword_code : this.data_fillter.keyword_code,
                keyword_name : this.data_fillter.keyword_name,
                keyword_phone : this.data_fillter.keyword_phone,
                keyword_email : this.data_fillter.keyword_email,
                ord_date_end : this.data_fillter.ord_date_end,
                ord_date_start : this.data_fillter.ord_date_start,
            };
            this.idSelect = [];
            this.selectAll = false;
            let data = {};
            await apiGet('v2/profile/products/order', params).then(res => {
                if(res.data.current_page == 1){
                    this.order = res.data.db_listing.data;
                    this.last_page =  res.data.db_listing.last_page;
                    this.next_page =  res.data.db_listing.next_page;
                    this.current_page =  res.data.db_listing.current_page;
                    this.db_order_product =  res.data.db_order_product;
                    this.countTotal     =   res.data.countTotal;
                    this.countSuccess = res.data.countSuccess;
                    this.countConfirm = res.data.countConfirm;
                    this.total_money = res.data.total_money;
                    this.countHasfail = res.data.countHasfail;
                    this.conntNewOrders = res.data.conntNewOrders;

                }
                data = res.data;
            });

            // if(data.db_listing.data.length == 0){
            //     this.getDataAction(page - 1);
            // }else{
                this.order = data.db_listing.data;
                this.last_page = data.db_listing.last_page;
                this.next_page = data.db_listing.next_page;
                this.current_page = data.db_listing.current_page;
                this.total_money = data.total_money;
                this.db_order_product =  data.db_order_product;
            // }
        }
    },
    watch: {
        selectAll(val){
            this.idSelect = [];
            if(val){
                this.order.map(item => {
                    this.idSelect.push(item.id);
                })
            }
        },
        idSelect: {
            handler(val){
                let count = 0;
                this.order.map(item => {
                    count += 1;
                });
                if(val.length == count && count > 0){
                    this.selectAll = true;
                }
            },
            deep: true,
        },
        dialog(){
            this.getUserCategory(this.current_page)
        }

    }
}
</script>

<style lang="scss">
    .pro_name{
        a:hover{
            text-decoration: none;
        }
    }
    .border{
        border: 1px solid #e5e5e5;
    }
    .border-top{
        border-top: 1px solid #e5e5e5;
    }
    .border-left{
        border-left: 1px solid #e5e5e5;
    }
    .border-right{
        border-right: 1px solid #e5e5e5;
    }
    .border-bottom{
        border-bottom: 1px solid #e5e5e5;
    }
    .w-80{
        width : 80%;
    }
    .w-30{
        width : 30%;
    }
    .w-20{
        width : 20%;
    }
    
    .w-15{
        width : 15%;
    }
    .w-85{
        width : 85%;
    }
    .img-tab-1{
        padding-left: 0;
        .icon-cat{
            img{
                width: 50px !important;
                height: 50px !important;
                object-fit: cover;
                border-radius: 10px;
                box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08);
            }
        }
    }
    .font-12px{
        font-size: 12px;
    }
    .text-oranges{
        color : #fd7e14;
    }
    .table-mobile {
        .w-btn {
            width: calc( 50% - 8px );
        }
        .checkbox-mobile {
            top: 19px !important;
            left: 7px !important;
        }
    }
    .price-tab-old{
        margin-top: 3px;
        font-size: 12px;
        text-decoration-line: line-through;
        color: #6c757d;
    }
    .text-promotion{
        margin-top: 3px;
        font-size: 11px;
    }
    .table thead th {
        vertical-align : middle;
    }
    .list-raovat table .name-rv{
        display : revert;
    }
    .font-22px{
        font-size : 22px;
    }
    .name-rv{
        .cat-child{
            font-size: 13px;
        }
    }
    .progress{
        height: 0.5rem!important;
    }

</style>
